import * as React from "react";
import { store } from "./store";
import { Provider } from "react-redux";

function StoreProvider({ children }: React.PropsWithChildren<unknown>) {
    return <Provider store={store}>{children}</Provider>;
}

export { StoreProvider };
